import { makeStyles } from 'tss-react/mui';
import { WbGrid, WbGridCol, WbHeading, WbIcon } from '@workbench/react';
import MailToButton from '../MailToButton';
import { OPERATING_FLUID_MAIL_ADDRESS } from '../../utils/links';
import { red } from '@mercedes-benz/mui5-theme/build/main/lib/Colors';
import Overlay from '../Overlay';

const useStyles = makeStyles()(() => ({
    iconColor: {
        color: red[45],
        '--size': '45px',
        paddingRight: 2,
    },
    text: {
        alignItems: 'center',
        justifyContent: 'start',
        display: 'inline-flex',
    },
}));

function DataIsIncomplete() {
    const { classes } = useStyles();
    return (
        <Overlay>
            <WbGrid>
                <WbGridCol mq1={8}>
                    <WbGrid className={classes.text}>
                        <WbIcon name="bds/exclamation-mark-circle-outline/24" className={classes.iconColor}></WbIcon>

                        <WbHeading size="l">{'Error'}</WbHeading>
                    </WbGrid>
                    <WbHeading size="xs">
                        {
                            'Ein unerwarteter Fehler ist aufgetreten. Bitte laden Sie die Seite erneut. Sollte der Fehler weiterhin auftreten, wenden Sie sich bitte an '
                        }
                        <MailToButton mailto={OPERATING_FLUID_MAIL_ADDRESS} label={OPERATING_FLUID_MAIL_ADDRESS} />
                    </WbHeading>
                    <WbHeading size="xs">
                        {
                            'An unexpected error has occurred. Please reload the page. If the error still occurs, please contact '
                        }
                        <MailToButton mailto={OPERATING_FLUID_MAIL_ADDRESS} label={OPERATING_FLUID_MAIL_ADDRESS} />
                    </WbHeading>
                </WbGridCol>
            </WbGrid>
        </Overlay>
    );
}

export default DataIsIncomplete;
